var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 35 35.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 35,
    height: 7.785
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.092,
    y: 10.653,
    width: 15.908,
    height: 24.348
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.653,
    width: 15.908,
    height: 24.348
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostView);
export default __webpack_public_path__ + "static/media/HostView.23eb56ef52804067a7afcfcbed07e09b.svg";
export { ForwardRef as ReactComponent };